export default "__VITE_ASSET__z9IKaPLP__"